export type Industry = {
  id: string;
  name: string;
  icon: string;
  blurb: string;
  highlight: string;
};

/**
 * A focused, curated set of industries — not an exhaustive list.
 * These are the sectors where our automation work has the highest
 * leverage and clearest ROI stories.
 */
export const industries: Industry[] = [
  {
    id: 'healthcare',
    name: 'Healthcare Practices',
    icon: 'medical_services',
    blurb: 'Patient scheduling, intake forms, records management, and insurance verification — automated end-to-end so your front desk breathes again.',
    highlight: '40% faster patient onboarding',
  },
  {
    id: 'real-estate',
    name: 'Real Estate Brokerages',
    icon: 'home_work',
    blurb: 'Lead qualification, automated showings, contract routing, and client follow-up sequences that keep every prospect warm without manual chasing.',
    highlight: '3× faster lead response',
  },
  {
    id: 'legal',
    name: 'Legal & Compliance Firms',
    icon: 'gavel',
    blurb: 'Document intake, case-file assembly, e-discovery workflows, and deadline tracking — built around your matter management stack with audit trails.',
    highlight: '60% less manual data entry',
  },
  {
    id: 'ecommerce',
    name: 'E-commerce & Retail',
    icon: 'shopping_cart',
    blurb: 'Inventory sync, order routing, support deflection, and returns processing — wired into your store so growth does not become a staffing problem.',
    highlight: '50% fewer support tickets',
  },
  {
    id: 'finance',
    name: 'Financial Services',
    icon: 'account_balance',
    blurb: 'Client onboarding, KYC workflows, reporting pipelines, and compliance monitoring — with human-in-the-loop checkpoints where accuracy is non-negotiable.',
    highlight: '70% faster onboarding',
  },
  {
    id: 'manufacturing',
    name: 'Manufacturing & Supply Chain',
    icon: 'precision_manufacturing',
    blurb: 'Procurement automation, quality tracking, supplier comms, and reporting — connecting your shop floor systems to the back office without another spreadsheet.',
    highlight: '35% fewer procurement delays',
  },
];
